module.exports = __webpack_public_path__ + "img/empty.0bc9958e.png";